const DOWNFILE = "/drive/export";

export const downFile = { DOWNFILE };
